<div class="container">
  <div class="form-row justify-content-center">
    <div class="col-sm-12 form-row justify-content-center">
      <div
        class="col-6 tabs-button"
        [ngClass]="{ 'tabs-button-active': currentMode === 'questionnaire' }"
        (click)="changeMode('questionnaire')"
      >
        <p class="title-text-2">Questionnaires</p>
      </div>
      <div
        class="col-6 tabs-button"
        [ngClass]="{ 'tabs-button-active': this.currentMode === 'template' }"
        (click)="changeMode('template')"
      >
        <p class="title-text-2 text-center">My Templates</p>
      </div>
    </div>
  </div>

  <div class="row mt-5" *ngIf="this.currentMode === 'questionnaire'">
    <div class="col-12 mb-4 d-none d-md-block d-lg-block">
      <div class="mat-elevation-z8 margin-bottom-20">
        <table
          mat-table
          [dataSource]="questionnaires"
          matSort
          (matSortChange)="sortData($event)"
        >
          <ng-container matColumnDef="title">
            <th mat-header-cell *matHeaderCellDef>
              <span> Questionnaire Title </span>
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.questionnaireSchema.title }}
            </td>
          </ng-container>
          <ng-container matColumnDef="subscriberName">
            <th
              mat-header-cell
              *matHeaderCellDef
              sortActionDescription="Sort by Subscriber Name"
            >
              <span>Subscriber Name</span>
            </th>
            <td mat-cell *matCellDef="let element">
              <span> {{ getFullName(element.user) }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="createdAt">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              sortActionDescription="Sort by Published On"
            >
              Published On
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.createdAt | date: 'dd-MM-yyyy h:mm' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="answeredAt">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              sortActionDescription="Sort by Answered On"
            >
              <span> Response Received On </span>
            </th>
            <td mat-cell *matCellDef="let element">
              <span *ngIf="element.response?.createdAt">
                {{ element.response.createdAt | date: 'dd-MM-yyyy h:mm' }}
              </span>
              <span *ngIf="!element.response?.createdAt"> Pending </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element">
              <button
                mat-stroked-button
                class="action-button next"
                *ngIf="!element.response"
                (click)="viewForm(element)"
              >
                View Questionnaire
              </button>

              <button
                mat-stroked-button
                class="action-button next"
                *ngIf="element.response"
                (click)="viewAnswerForm(element)"
              >
                View Responses
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
        <div class="mat-paginator-container">
          <div class="mat-paginator-range-label">
            {{ totalRecords }} Results Found
          </div>
          <div class="mat-paginator-navigation">
            <mat-spinner *ngIf="isLoading" diameter="20"></mat-spinner>

            <button
              mat-button
              class="custom-page"
              [disabled]="pageNo === 0"
              (click)="goToPreviousPage()"
            >
              <mat-icon>arrow_left</mat-icon>
              Prev
            </button>
            <button
              mat-button
              class="custom-page"
              *ngFor="let pageNumber of getPageNumbers()"
              [disabled]="pageNumber === pageNo"
              (click)="goToPage(pageNumber)"
            >
              {{ pageNumber + 1 }}
            </button>
            <button
              mat-button
              class="custom-page"
              [disabled]="
                !totalRecords || pageNo === getTotalPages() - 1 || isLoading
              "
              (click)="goToNextPage()"
            >
              Next
              <mat-icon>arrow_right</mat-icon>
            </button>
          </div>
        </div>
        <mat-paginator
          style="visibility: hidden; display: none"
          [pageSize]="limit"
          [pageIndex]="pageNo"
          [length]="totalRecords"
          [disabled]="isLoading"
        >
        </mat-paginator>
      </div>
    </div>
  </div>

  <div class="row mt-5" *ngIf="this.currentMode === 'template'">
    <div class="col-12 mb-4 d-none d-md-block d-lg-block">
      <div class="mat-elevation-z8 margin-bottom-20">
        <table
          mat-table
          matSort
          [dataSource]="templates"
          (matSortChange)="sortData($event)"
        >
          <ng-container matColumnDef="title">
            <th mat-header-cell *matHeaderCellDef>
              <span> Questionnaire Title </span>
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.questionnaireSchema.title }}
            </td>
          </ng-container>

          <ng-container matColumnDef="createdAt">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              sortActionDescription="Sort by Created At"
            >
              Created At
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.createdAt | date: 'dd-MM-yyyy h:mm' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element" class="min-width-column">
              <button
                mat-stroked-button
                class="action-button next"
                *ngIf="!element.response"
                (click)="viewEditorForm(element)"
              >
                View Questionnaire
              </button>

              <button
                mat-icon-button
                [matMenuTriggerFor]="menu"
                [disabled]="isLoading"
                aria-label="Delete template"
              >
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu" xPosition="after">
                <button mat-menu-item (click)="deleteTemplate(element)">
                  <mat-icon
                    class="material-symbols-outlined"
                    style="color: #e35f6c"
                    >do_not_disturb_on_outlined
                  </mat-icon>
                  <span style="color: #e35f6c">Delete Template</span>
                </button>
              </mat-menu>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="templateDisplayColumns"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: templateDisplayColumns"
          ></tr>
        </table>
        <div class="mat-paginator-container">
          <div class="mat-paginator-range-label">
            {{ totalRecords }} Results Found
          </div>
          <div class="mat-paginator-navigation">
            <mat-spinner *ngIf="isLoading" diameter="20"></mat-spinner>

            <button
              mat-button
              class="custom-page"
              [disabled]="pageNo === 0"
              (click)="goToPreviousPage()"
            >
              <mat-icon>arrow_left</mat-icon>
              Prev
            </button>
            <button
              mat-button
              class="custom-page"
              *ngFor="let pageNumber of getPageNumbers()"
              [disabled]="pageNumber === pageNo"
              (click)="goToPage(pageNumber)"
            >
              {{ pageNumber + 1 }}
            </button>
            <button
              mat-button
              class="custom-page"
              [disabled]="!totalRecords || pageNo === getTotalPages() - 1"
              (click)="goToNextPage()"
            >
              Next
              <mat-icon>arrow_right</mat-icon>
            </button>
          </div>
        </div>

        <mat-paginator
          style="visibility: hidden; display: none"
          [pageSize]="limit"
          [pageIndex]="pageNo"
          [length]="totalRecords"
          [disabled]="isLoading"
        >
        </mat-paginator>
      </div>
    </div>
  </div>

  <div *ngIf="error" class="text-danger text-center">
    {{ error }}
  </div>
</div>

<div
  class="modal fade p-0"
  id="open-edit-question"
  tabindex="-1"
  role="dialog"
  aria-labelledby="patientToPatientLinkTitle"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <mat-icon
          class="material-symbols-outlined"
          style="cursor: pointer; float: right"
          (click)="closeModal()"
          aria-hidden="false"
          aria-label="Example home icon"
          fontIcon="close"
        ></mat-icon>
      </div>
      <div class="modal-body">
        <survey-creator [model]="model"></survey-creator>
      </div>
      <div *ngIf="currentMode === 'template'" class="modal-footer">
        <div class="row justify-content-md-end">
          <button
            mat-stroked-button
            class="action-button next"
            *ngIf="!isLoading"
            (click)="updateTemplate()"
          >
            Update Template
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade p-0"
  id="open-question"
  tabindex="-1"
  role="dialog"
  aria-labelledby="patientToPatientLinkTitle"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <mat-icon
          class="material-symbols-outlined"
          style="cursor: pointer; float: right"
          (click)="closeModal()"
          aria-hidden="false"
          aria-label="Example home icon"
          fontIcon="close"
        ></mat-icon>
      </div>
      <div class="modal-body">
        <survey [model]="surveyModel"></survey>
      </div>
    </div>
  </div>
</div>
